import { useTranslation } from 'react-i18next';
import { TaskTemplateDetailsPanel } from '@/views';
import { Icon, Page } from '@/components';
import { useParams } from 'react-router-dom';
import { useGetTaskTemplateDetailsQuery } from '@/redux';
import { AdminTabKeys } from '@/views/Admin/AdminTabs';

const useId = () => {
  const { id } = useParams<'id'>();
  return id!;
};

export function GlobalTaskTemplateDetailsPage() {
  const { t } = useTranslation();
  const id = useId();
  const { data } = useGetTaskTemplateDetailsQuery({ id });
  const title = data?.name ?? t('fetchFallbackTitle');
  const backRoute = `/admin#${AdminTabKeys['task-templates']}`;

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href={backRoute}>{t('taskTemplates.title')}</Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="template" />}
          color="#EFAC4E"
        >
          <TaskTemplateDetailsPanel
            id={id}
            readonly={false}
            editRoute={(id) => `/admin/task-templates/${id}/edit`}
          />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
